import type { FC, ReactNode } from 'react'

import { WhatsappIcon } from '@/components/generals/whatsapp-icon'
import { defaultWhatsappMessage, whatsappLink } from '@/constants/site'

export const WhatsappFloat: FC = (): ReactNode => {
    return (
        <a
            href={whatsappLink(defaultWhatsappMessage)}
            target='_blank'
            rel='noopener noreferrer'
            aria-label='Chat with Loveth Tasty on WhatsApp'
            className='group fixed right-4 bottom-4 z-40 inline-flex items-center gap-3 rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-orange focus-visible:ring-offset-2 sm:right-6 sm:bottom-6'
        >
            <span
                aria-hidden='true'
                className='pointer-events-none hidden translate-x-2 rounded-full bg-brand-charcoal px-4 py-2 text-sm font-medium text-brand-white opacity-0 shadow-lg transition-all duration-300 group-hover:translate-x-0 group-hover:opacity-100 sm:inline-block'
            >
                Chat with us
            </span>

            <span className='relative inline-flex size-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_16px_40px_-12px_rgba(37,211,102,0.75)] transition-transform duration-300 group-hover:scale-105'>
                <span
                    aria-hidden='true'
                    className='absolute inset-0 rounded-full bg-[#25D366] opacity-50 motion-safe:animate-ping motion-safe:[animation-duration:2.8s] motion-safe:[animation-iteration-count:4]'
                />
                <WhatsappIcon className='relative size-7' />
            </span>
        </a>
    )
}
